module.exports = __webpack_public_path__ + "img/cydeen.99e96864.png";